import type { ApiParamsDefinition } from '@/api/types/api-definition';

import { httpRequest } from '../request';

type SendFlexOffersRequest = ApiParamsDefinition['GET:/api/flexoffer']['params'];

export default {
  sendFlexOffers: (data: SendFlexOffersRequest) =>
    httpRequest('GET:/api/flexoffer', { params: data }),
  paymentEnter: () =>
    httpRequest('GET:/api/customer/payment_enter', undefined, { errorMsg: false }),
};
